/*
 * @Author: your name
 * @Date: 2020-08-05 20:54:25
 * @LastEditTime: 2023-03-16 16:48:30
 * @LastEditors: fangteng fangteng@yaomaitong.cn
 * @Description: In User Settings Edit
 * @FilePath: /ksh-doctor/src/service/LiveService.js
 */
import request from '@/utils/request'
import { API } from './apiConfig'

export function onRecordLiveViewTime(req) {
	return request({ method: 'get', url: API.onRecordLiveViewTime, params: req })
}


export function getIndexLiveList(pageNo = 1, pageSize = 20, sceneType = '',status = '') {
	return request({ method: 'get', url: API.getIndexLiveList, params: { pageSize, pageNo, sceneType,status } })
}

export function getCouldLiveList(pageNo = 1, pageSize = 20, sceneType = '5') {
	return request({ method: 'get', url: API.getCouldLiveList, params: { pageNo, pageSize, sceneType } })
}

export function getCouldMeetingList(pageNo = 1, pageSize = 20, sceneType = '6') {
	return request({ method: 'get', url: API.getCouldLiveList, params: { pageNo, pageSize, sceneType } })
}

export function getCouldStarList(pageNo = 1, pageSize = 20) {
	return request({ method: 'get', url: API.getCouldStarList, params: { pageNo, pageSize } })
}

export function getLivePacketKey(liveId = '') {
	return request({ method: 'get', url: API.getLivePacketKey, params: { liveId } })
}

export function onReceiveLivePacket(req) {
	// 领取趣直播红包
	return request({ method: 'get', url: API.onReceiveLivePacket, params: req })
}

export function onReceiveLiveGift(codeId = '') {
	return request({ method: 'get', url: API.onReceiveLiveGift, params: { codeId } })
}

export function getLiveHistoryMsg(data) {
	return request({ method: 'get', url: API.getLiveHistoryMsg, params: data })
}

export function getRecommenLiveList({ pageNo = 1, pageSize = 20, liveId = '', doctorId = '', isOrderByViewCount = false, sceneType = '5' }) {
	return request({
		method: 'get',
		url: API.getRecommenLiveList,
		params: { pageSize, pageNo, liveId, doctorId, isOrderByViewCount, sceneType }
	})
}

export function getRecommenMeetingList({ pageNo = 1, pageSize = 20, liveId = '', doctorId = '', isOrderByViewCount = false, sceneType = '6' }) {
	return request({
		method: 'get',
		url: API.getRecommenLiveList,
		params: { pageSize, pageNo, liveId, doctorId, isOrderByViewCount, sceneType }
	})
}

export function getLiveGift({ pageNo = 1, pageSize = 20 }) {
	return request({ method: 'get', url: API.getLiveGift, params: { pageSize, pageNo } })
}

export function putOnShelves({ liveId = '', isHide = true }) {
	return request({ method: 'get', url: API.putOnShelves, params: { liveId, isHide } })
}

export function dealChatMsg(data) {
	return request({ method: 'get', url: API.dealChatMsg, params: data })
}

export function getCashDetail({ pageNo = 1, pageSize = 20, liveId = '' }) {
	return request({ method: 'get', url: API.getCashDetail, params: { pageSize, pageNo, liveId } })
}

export function getLiveSimpleInfo({ liveId = '', doctorId }) {
	return request({ method: 'get', url: API.getLiveSimpleInfo, params: { liveId, doctorId } })
}

export function getBlackLiveList(data) {
	return request({ method: 'get', url: API.getBlackLiveList, params: data })
}

export function handleBlackList(data) {
	return request({ method: 'get', url: API.handleBlackList, params: data })
}

export function getLiveHistoryMessageList(data) {
	return request({ method: 'get', url: API.getLiveHistoryMessageList, params: data })
}

export function getSpeakerLiveDetail(liveId) {
	return request({ method: 'get', url: API.getSpeakerLiveDetail, params: { liveId } })
}

export function getLiveDynamicData(liveId = '') {
	return request({ method: 'get', url: API.getLiveDynamicData, params: { liveId,t: new Date().getTime() } })
}

export function shareScene(contentId = '', contentType = '') {
	return request({ method: 'get', url: API.shareScene, params: { contentId, contentType } })
}

export function getGiftList() {
	return request({ method: 'get', url: API.getGiftList })
}

export function getHelpList(liveId = '') {
	return request({ method: 'get', url: API.getHelpList, params: { liveId } })
}

export function getMyHelpList(liveId = '') {
	return request({ method: 'get', url: API.getMyHelpList, params: { liveId } })
}

export function payGift(data) {
	return request({ method: 'post', url: API.payGift, data })
}

export function checkItemGift(liveGiftId) {
	return request({ method: 'get', url: API.checkItemGift, params: { liveGiftId } })
}
export function submitLiveExam(answers = [], codeId = '', is4Twice = false) {
	return request({
		url: API.submitLiveExam,
		method: 'post',
		data: {
			answers,
			codeId,
			is4Twice
		},
	})
}
export function onReceiveLiveExamGift(codeId = '') {
	return request({
		url: API.onReceiveLiveExamGift,
		method: 'post',
		params: {
			codeId
		},
	})
}
export function onUnlockScene(data) {
	return request({
		url: API.onUnlockScene,
		method: 'post',
		data
	})
}
export function permissionForLive(params) {
	return request({
		url: API.permissionForLive,
		method: 'get',
		params
	})
}

// 获取红包题目
export function getRedPacketExam(params) {
	return request({
		url: API.getRedPacketExam,
		method: 'get',
		params
	})
}
//一次、二次提交红包题目 根据前端传递的参数判断是否是二次答题
export function redPacketExamAnswer(data) {
	return request({
		url: API.redPacketExamAnswer,
		method: 'POST',
		data
	})
}
// 根据趣直播ID查看红包
export function getRedPacket(params) {
	return request({
		url: API.getRedPacket,
		method: 'get',
		params
	})
}

// 领取趣直播红包
export function receiveRedPacket(params) {
	return request({
		url: API.receiveRedPacket,
		method: 'get',
		params
	})
}
// 手动结算第一次提交的红包题目答案
export function settleRedPacketExamAnswer(params){
	return request({
		url: API.settleRedPacketExamAnswer,
		method: 'get',
		params
	})
}


export function onlineStremCount(params) {
	return request({
		url: API.onlineStremCount,
		method: 'get',
		params
	})
}
